<template>
  <v-container fluid>
    <v-data-table
      :headers="dessertHeaders"
      :items="others"
      :search="search"
      item-key="id_entrance"

      class="elevation-1"
    >
      <template v-slot:top>
        <v-toolbar flat>
          <v-toolbar-title>Entrance Data</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-text-field
            v-model="search"
            solo
            dense
            append-icon="mdi-magnify"
            label="Search Entrance Data"
            class="mr-3 white"
            outlined
            hide-details
          ></v-text-field>
        </v-toolbar>
      </template>
      <template #[`item.rate_for_adult`]="{ item }">
        Rp. {{ Number(item.rate_for_adult).toLocaleString() }}
      </template>
      <template #[`item.rate_for_child`]="{ item }">
        Rp. {{ Number(item.rate_for_child).toLocaleString() }}
      </template>
      <template #[`item.actions`]="{ item }">
        <v-btn
          small
          class="mr-2 text-capitalize primary"
          @click="UseService(item)"
        >
          Use Service
          <v-icon>{{ icons.mdiPlus }}</v-icon>
        </v-btn>
      </template>
      <template v-slot:no-data>
        <v-btn
          color="primary"
          @click="initialize"
        >
          Reset
        </v-btn>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import numeral from 'numeral'

import axios from 'axios'
import {
  mdiPencil,
  mdiTrashCan,
  mdiPlus,
  mdiClose,
  mdiCalendar,
} from '@mdi/js'

export default {

  data() {
    return {
      rate: 0,
      errors: {},
      icons: {
        mdiPencil,
        mdiTrashCan,
        mdiPlus,
        mdiClose,
        mdiCalendar,
      },
      modal: false,
      modal5: false,
      expanded: [],
      singleExpand: true,
      dialog: false,
      editedIndex: -1,
      search: '',
      form: {
        entrance_name: '',
        id_entrance: '',
        rate_for_adult: '',
        rate_for_child: '',
        note: '',
      },
      service: [],
      dessertHeaders: [
        { text: 'Entrance Name', value: 'entrance_name' },
        { text: 'Rate For Adult', value: 'rate_for_adult' },
        { text: 'Rate For Child', value: 'rate_for_child' },
        { text: 'Note', value: 'note' },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false,
          width: 200,
        },
      ],

      others: [],

    }
  },
  computed: {
    formTitle() {
      return this.editedIndex === -1 ? 'Add New Entrance' : 'Edit Entrance'
    },
    TittleButton() {
      return this.editedIndex === -1 ? 'Save Entrance' : 'Update Entrance'
    },
  },

  mounted() {
    this.initialize()
  },
  methods: {
    UseService(item) {
      this.$root.$emit('MakeItinerary', item, 'Entrance')
    },
    ConvertNumeral() {
      const harga = this.form.rate_for_child
      const string = numeral(harga).format('0,0')
      this.form.rate_for_child = string
    },
    CekDialog() {
      this.form = {
        other_name: '',
        id_other: '',
        rate: '',
        note: '',
      }
      this.dialog = false
    },

    editItem(item) {
      this.editedIndex = this.others.indexOf(item)
      this.form = item
      this.dialog = true
    },
    deleteItem(item) {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/DeleteEntrance', item).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    initialize() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.get('auth/Entrance').then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.others = response.data.data
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
    Save() {
      this.$root.$emit('PesanLoading', 'Processing Data')
      axios.post('auth/SaveEntrance', this.form).then(response => {
        this.$root.$emit('PesanResponse', response.data.message, 'primary')
        this.initialize()
        this.dialog = false
        this.CekDialog()
        this.editedIndex = -1
      }).catch(err => {
        this.errors = err.response.data.errors
        this.$root.$emit('PesanResponse', err.response.data.message, 'red')
      })
    },
  },
}
</script>
